

















import { Vue, Component, Model, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class SearchInput extends Vue {
  @Model("input", { type: String }) readonly value!: boolean;
  @Prop({ default: "" }) placeholder!: string;
}
